// extracted by mini-css-extract-plugin
module.exports = {"extraButtons":"WorkspaceHeader_extraButtons__TKFSR","projectHeader":"WorkspaceHeader_projectHeader__aK9Oh"};